import { render, staticRenderFns } from "./CourseIncludes.vue?vue&type=template&id=87bfb6b4"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CourseContent: require('/vercel/path0/components/CourseContent.vue').default})
